export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14937.03a134ed.jpg";